import { useState } from "react";
import { Checkbox, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { ApiError } from "../api/client";
import { type Show, shows } from "./api";

/**
 * *This is a test run* (`R-SHOW-26a`) — the tickbox that keeps `/live` from sending anybody here.
 *
 * Offered in every state, because the show a host most needs to tick is the rehearsal already on
 * air. It changes nothing else about the show: its own link still opens and it still sells, so a
 * rehearsal is a rehearsal of the real thing.
 *
 * Saved the moment it is ticked, like the redirect beside it — there is nothing else to fill in.
 */
export function ShowTestRun({
  show,
  mayEdit,
  onChanged,
}: {
  show: Show;
  /** The host's. A moderator sees the state and cannot change it. */
  mayEdit: boolean;
  onChanged: () => Promise<void>;
}) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  async function save(testRun: boolean) {
    setBusy(true);
    setError(undefined);
    try {
      await shows.edit(show.id, { testRun });
      await onChanged();
    } catch (failure) {
      setError(failure instanceof ApiError ? failure.message : t("shows.unreachable"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Stack gap={4}>
      <Checkbox
        size="sm"
        label={t("shows.testRun")}
        checked={show.testRun}
        disabled={!mayEdit || busy}
        onChange={(event) => void save(event.currentTarget.checked)}
      />
      <Text size="xs" c={error ? "red" : "dimmed"}>
        {error ?? (show.testRun ? t("shows.testRunOn") : t("shows.testRunHelp"))}
      </Text>
    </Stack>
  );
}
